import { api, apiAdn, apiUtils } from "./common";

export function resetDatabasePooling() {
  return Promise.all([
    api.post("/reset-pool"),
    apiAdn.post("/reset-pool"),
    apiUtils.post("/reset-pool")
  ]);
}
